import { MenuContainer } from '@zendeskgarden/react-menus';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import styled from 'styled-components';

import { ProjectActions } from '../../../../../../actions/project';

import SightPlannerLogo from '../../../../NavBarNew/sight.svg';
import SightIssuesLogo from '../../../../NavBarNew/sight-issues.svg';

const CustomMenuContainer = styled.div`
  z-index: 1071;
  position: relative;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  marginleft: 0px;
  :focus {
    outline: none;
  }
`;

CustomMenuContainer.defaultProps = {
  theme: {
    main: 'main',
  },
};

const CustomMenuItem = styled.div`
  /* padding: 8px 4px; */
  background-color: ${({ focused }) => (focused ? 'grey' : 'initial')};
  cursor: pointer;
  :hover {
    color: #16181b;
    text-decoration: none;
    background-color: #f8f9fa;
  }
  display: block;
  width: 100%;
  padding: 0.25rem 0.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
`;

CustomMenuItem.defaultProps = {
  theme: {
    main: 'main',
  },
};

@connect()
class ProductPicker extends React.Component {
  initialState = {
    selectedKey: 'Unknown',
  };

  state = {
    isOpen: false,
  };

  handleStateChange = state => {
    const { enableTooltip, disableTooltip } = this.props;
    state.isOpen ? disableTooltip() : enableTooltip();
    this.setState({
      isOpen: state.isOpen,
    });
  };

  logoPicker = () => {
    const { product } = this.props;

    switch (product) {
      case "issues":
        return SightIssuesLogo;
      default:
        return SightPlannerLogo;
    }
  }

  render() {
    const { dispatch, currentProjectId } = this.props;
    const { isOpen } = this.state;
    return (
      <MenuContainer
        theme="main"
        zIndex={1071}
        placement="end-bottom"
        isOpen={this.state.isOpen}
        onStateChange={this.handleStateChange}
        onChange={selectedKey => {}}
        trigger={({ getTriggerProps, triggerRef, isOpen }) => {
          const triggerProps = getTriggerProps({ ref: triggerRef });
          return (
            <div {...triggerProps} className="fa-icon-style">
              <img src={this.logoPicker()} alt="planz Logo" style={{ height: 37 }} />
            </div>
          );
        }}
      >
        {({ getMenuProps, menuRef, placement, getItemProps, focusedKey }) => (
          <CustomMenuContainer
            {...getMenuProps({
              innerRef: menuRef,
            })}
            theme="main"
          >
            {[
              {
                id: 'planner',
                url: `/project/${currentProjectId}/planner`,
                display: 'Planner',
              },
              //{
              // id: 'issues',
              // url: `/project/${currentProjectId}/issues`,
              // display: 'Issues',
              //},
            ].reduce((prev, item) =>
              [
                ...prev,
                <CustomMenuItem
                  {...getItemProps({
                    key: item.id,
                    textValue: item.id,
                  })}
                  onClick={() => {
                    dispatch(
                      ProjectActions.changeProducts(item.id)
                    );
                    dispatch(push(item.url));
                    this.setState({
                      isOpen: !isOpen
                    })
                  }}
                  theme="main"
                >
                  <div
                    style={{
                      display: 'block',
                      width: 'auto',
                      color: '#5e97be',
                    }}
                  >
                    {' '}
                    {item.display}
                  </div>
                </CustomMenuItem>,
              ], [])}
          </CustomMenuContainer>
        )}
      </MenuContainer>
    );
  }
}

export default ProductPicker;



// WEBPACK FOOTER //
// ./src/components/toolbars/IconNavList/industry/construction/ProductPicker/ProductPicker.js